import { render, staticRenderFns } from "./TablaPadres.vue?vue&type=template&id=dffa3f6c&scoped=true&"
import script from "./TablaPadres.vue?vue&type=script&lang=js&"
export * from "./TablaPadres.vue?vue&type=script&lang=js&"
import style0 from "./TablaPadres.vue?vue&type=style&index=0&id=dffa3f6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dffa3f6c",
  null
  
)

export default component.exports